import { enumToOptions } from './util';

export enum VoucherNursingCareAssessmentPlaceEnum {
    HOME = 'home',
    SERVICE = 'service',
    OTHER = 'other',
}

export const voucherNursingCareAssessmentPlaceEnumOptions = enumToOptions(VoucherNursingCareAssessmentPlaceEnum, 'folder.voucher.nursingCarePlan.createAssessment.fields.placeFields.');
